const m = require('minthril');
const { component } = require('../../../component');
const { Breadcrumbs } = require('../../../components/breadcrumbs');

const PrerenderComparisonPage = component(() => ({
  view: () => m('article.panel.docs-page.prerender-comparison', [
    m(Breadcrumbs, {
      items: [
        { label: 'Docs', href: '/docs' },
        { label: 'Comparisons', href: '/docs/comparisons' },
        { label: 'Prerender.io: Mid Engine Co' }
      ]
    }),
    m('h2', 'Building Mid Engine Co with Prerender.io'),
    m('p', [
      'Prerender.io renders JavaScript pages for search crawlers and returns cached HTML through an integration ' +
      'in your request path. That integration identifies crawler requests and routes them to Prerender.io; human ' +
      'visitors continue to the existing storefront. ',
      m('a', {
        href: 'https://prerender.io/',
        target: '_blank',
        rel: 'noopener noreferrer'
      }, 'Prerender.io'),
      ' · ',
      m('a', {
        href: 'https://docs.prerender.io/docs/how-does-prerender-work',
        target: '_blank',
        rel: 'noopener noreferrer'
      }, 'How Prerender.io works')
    ]),
    m('p',
      'For Mid Engine Co, the storefront could stay a browser-rendered Mithril SPA. Product pages would be ' +
      'rendered for crawlers, while shoppers would load the normal app and keep their own live Shopify cart. ' +
      'This is a focused way to make crawler requests receive HTML without rebuilding the storefront around SSR.'
    ),
    m('h3', 'The key difference is who gets the prepared page'),
    m('p',
      'Prerender.io is primarily a crawler-rendering path: your server, CDN, or proxy must recognize the relevant ' +
      'crawler user agents and send those requests to the service. Spache sits in front of the site for ordinary ' +
      'visits too, so people as well as crawlers can receive prepared HTML. The browser app then starts normally, ' +
      'keeps the visitor-specific cart live, and can reuse captured API responses during startup. That last part ' +
      'means the app can receive matching captured data without waiting for another request to the origin.'
    ),
    m('div.prerender-comparison__table-wrap', [
      m('table.prerender-comparison__table', [
        m('thead', m('tr', [
          m('th', 'Consideration'),
          m('th', 'With Prerender.io…'),
          m('th', 'With Spache…')
        ])),
        m('tbody', [
          m('tr', [
            m('th', 'Routing crawler requests'),
            m('td', 'Configure middleware, server, or CDN logic to detect crawler user agents and forward those requests to Prerender.io.'),
            m('td', 'Automatic')
          ]),
          m('tr', [
            m('th', 'Keeping crawler coverage current'),
            m('td', 'Use the integration’s bot list and add user agents when needed.'),
            m('td', 'Automatic')
          ]),
          m('tr', [
            m('th', 'Serving rendered HTML to shoppers'),
            m('td', 'The regular visitor path still serves the storefront; the browser app renders the page for shoppers.'),
            m('td', 'Automatic')
          ]),
          m('tr', [
            m('th', 'Reusing API data during app startup'),
            m('td', 'The rendered snapshot includes the result in its HTML; the live browser app still makes its normal API requests.'),
            m('td', 'Eligible responses are captured and replayed to the app; JSON GET capture is automatic, and non-GET capture is configurable.')
          ]),
          m('tr', [
            m('th', 'Refreshing rendered pages'),
            m('td', 'Configure cache expiration, and arrange refreshes or invalidation when content changes sooner.'),
            m('td', 'Automatic, configurable')
          ]),
          m('tr', [
            m('th', 'Hosting rendered output'),
            m('td', 'Prerender.io manages its rendered-page cache; your integration must connect it to crawler requests.'),
            m('td', 'Automatic')
          ]),
          m('tr', [
            m('th', 'Keeping the cart visitor-specific'),
            m('td', 'The shopper’s normal browser app loads and manages their live cart.'),
            m('td', 'Automatic')
          ])
        ])
      ])
    ]),
    m('p', [
      'Prerender.io is a good fit when the goal is to provide rendered pages to crawlers and you are comfortable ' +
      'maintaining the crawler-routing integration. Spache takes a broader role: prepared HTML is part of the ' +
      'normal serving path for every visitor, with rendering, refreshing, and delivery managed together. For ' +
      'Mid Engine Co, that means no crawler-specific routing rules to maintain and no separate SSR implementation.'
    ]),
    m('p', [
      'Further reading: ',
      m('a', {
        href: 'https://docs.prerender.io/docs/how-to-add-additional-bots',
        target: '_blank',
        rel: 'noopener noreferrer'
      }, 'configure crawler user agents'),
      ' and ',
      m('a', {
        href: 'https://docs.prerender.io/docs/modify-the-cache-expiration',
        target: '_blank',
        rel: 'noopener noreferrer'
      }, 'Prerender.io cache expiration'),
      ' and ',
      m('a', {
        href: 'https://docs.prerender.io/docs/best-practices',
        target: '_blank',
        rel: 'noopener noreferrer'
      }, 'waiting for AJAX-backed content to finish rendering')
    ])
  ])
}));

module.exports = { PrerenderComparisonPage };
